// Build-time feature flags.
//
// Flags are driven by REACT_APP_* environment variables defined per-environment
// in .env-cmdrc (dev / staging / prod) and inlined by Create React App at build
// time. Because env values are always strings, compare against 'true' to derive
// a real boolean.
//
// Use these flags to enable not-yet-prod-ready features in dev/staging while
// keeping them hidden in production, instead of branch-divergent commenting.
//
// Convention: for a feature "X", add REACT_APP_FEATURE_X to all three .env-cmdrc
// sections (true for dev/staging, false for prod) and export an X_ENABLED flag
// here. Gate nav items via `enabled: X_ENABLED` (ListNavigationTab / HeaderSideBar
// only render items with enabled === true) and gate routes via conditional spread
// so the route object is omitted entirely when the flag is off.

export const FLEET_AI_ENABLED = process.env.REACT_APP_FEATURE_FLEET_AI === 'true';

export const REPORTS_ENABLED = process.env.REACT_APP_FEATURE_REPORTS === 'true';
